import React, { useEffect } from 'react';

interface IframePageProps {
  url: string;
  currentUser: any;
  onExternalLinkClick: (url: string, e: React.MouseEvent<HTMLAnchorElement>) => void;
  urlMap: any;
}

function IframePage({ url, currentUser, onExternalLinkClick, urlMap }: IframePageProps) {

  const handleExternalLinkClick = (url: string, e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    onExternalLinkClick(url, e);
  };

  const handleOpenAllCards = (e: any) => {
    handleExternalLinkClick('ALL_CARDS', e) 
  }

  useEffect(() => {
    window.addEventListener(
      "message",
      (event) => {
        const trustedOrigins = [process.env.REACT_APP_METADATA, process.env.REACT_APP_PROPOSAL_MANAGEMENT, process.env.REACT_APP_DATA];
        if (!trustedOrigins.includes(event.origin)) return;
        const {url, type} = event.data;
        if(type === 'URL_Update' && url) {
          sessionStorage.setItem("refreshUrl", url);
          const currentUrl = new URL(window.location.href);
          const searchParams = currentUrl.searchParams.get("subSrc")
          if (searchParams) {
          // Find the entry in urlMap whose value is a prefix of searchParams
            const matchedEntry = Object.entries(urlMap).find(([key, value]) =>
              typeof value === "string" && searchParams.startsWith(value)
            );
            if (matchedEntry) {
              const [matchedKey, matchedValue] = matchedEntry;
              if (url.startsWith(matchedKey)) {
                const normalizedKey = matchedKey.endsWith('/') ? matchedKey.slice(0, -1) : matchedKey;
                let rest = url.slice(normalizedKey.length);
                if (rest.startsWith('/')) rest = rest.slice(1);
                const newSubSrc = `${matchedValue}${rest ? '/' + rest : ''}`;
                currentUrl.searchParams.set("subSrc", newSubSrc);
                window.history.replaceState(null, "", currentUrl.toString());
              }
            }
          }
        }
      },
      false,
    );
  }, [])

  return (
    <>
      {!currentUser ?
      <>
      <div className="crumbs">
        <a onClick={handleOpenAllCards} style={{ cursor: 'pointer' }}>Click here for "All Modules"</a>
      </div>
      <br />
      </> : ''} 
      <iframe
          src={url}
          title="External Page"
          style={{ width: '100%', height: 'calc(100vh - 84px)', backgroundColor: '#fff'}}
        />
    </>
  );
}

export default IframePage;